module.exports = __webpack_public_path__ + "img/jerry.fed35c22.png";